import { render, staticRenderFns } from "./AirspaceAdvisoryCard.vue?vue&type=template&id=813b14dc&"
import script from "./AirspaceAdvisoryCard.vue?vue&type=script&lang=js&"
export * from "./AirspaceAdvisoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports